import * as React from 'react';
import './login.css';
import Typography from '@mui/material/Typography';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { OutlinedInputProps } from '@mui/material/OutlinedInput';
import { alpha, styled } from '@mui/material/styles';
import {Button,IconButton, InputAdornment} from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useAppDispatch } from '../../store/store'
import {auth} from '../../store/auth';
import {closeBackdrop} from '../../store/app';

const RedditTextField = styled((props: TextFieldProps) => (
    <TextField
        InputProps={{ disableUnderline: true } as Partial<OutlinedInputProps>}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiFilledInput-root': {
        color: "#000",
        overflow: 'hidden',
        borderRadius: 4,
        backgroundColor: theme.palette.mode === 'light' ? '#F3F6F9' : '#fff',
        border: '1px solid',
        transition: theme.transitions.create([
            'border-color',
            'background-color',
            'box-shadow',
        ]),
        '&:hover': {
            backgroundColor: 'var(--white)',

        },
        '&.Mui-focused': {
            backgroundColor: 'var(--white)',
            color:'#000',
            boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
        },
    },
    '& label.Mui-focused': {
        color: 'var(--dark)',
        opacity:'o.5'
    },
}));
const LoginSchema = Yup.object().shape({
    password: Yup.string()
        .min(2, "Por favor, ingresa más caracteres.")
        .max(50, "Por favor, reduce el número de caracteres.")
        .required( "Este campo es obligatorio."),
    email: Yup.string()
        .email( "Introduce una dirección de correo electrónico válida." )
        .required( "Este campo es obligatorio." ),

});
function Login() {
    const [showPassword, setShowPassword] = React.useState(false);
    const dispatch = useAppDispatch();
    const handleClickShowPassword = () => {

        setShowPassword(!showPassword);
    };
    React.useEffect(() => {
        dispatch(closeBackdrop())
    }, []);
    const {
        setFieldValue,
        errors,
        touched,
        submitForm,
        values,
        setValues,
    } = useFormik<{ password:string,email:string }>({
        initialValues: {password:'',email:''},
        validationSchema:LoginSchema,
        onSubmit: (values: { password:string,email:string }, formikHelpers) => {
            dispatch(auth({username:values.email,password:values.password}))
        },
    })


    return (
        <div className="contLogin">
            <div className="contBGLogin"></div>
            <div className="contFormLogin">
                <div className="infoForm">
                    <Typography variant="h1" className="title txt-green" gutterBottom>Bienvenido a</Typography>
                    <Typography variant="h2" className="subtitle txt-white" gutterBottom>WildTours</Typography>
                    <Typography variant="body1" className="textBody txt-white" gutterBottom>Ingresa tus datos para acceder</Typography>



                    <form>
                        <RedditTextField
                            label="Nombre de usuario"
                            value={values.email}
                            error={!!errors.email && !!touched.email}
                            helperText={(errors.email && touched.email)?'':''}
                            onChange={(event)=>{
                                setFieldValue("email", event.currentTarget.value??'')
                            }}
                            id="email-input"
                            variant="filled"
                            style={{ marginTop: 11 }}
                        />

                        <RedditTextField
                            label="Contraseña"
                            type={showPassword ? "text" : "password"}
                            id="password-input"
                            variant="filled"
                            value={values.password}
                            error={!!errors.password && !!touched.password}
                            helperText={(errors.password && touched.password)?'':''}
                            onChange={(event)=>{
                                setFieldValue("password", event.currentTarget.value??'')
                            }}
                            style={{ marginTop: 11 }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"

                                            onClick={handleClickShowPassword}
                                            edge="end"
                                        >
                                            {  showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />

                        <Button className="btn-full" onClick={()=>submitForm().then( )} disabled={values.email==="" && values.password===""}>Ingresar</Button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Login;
